import { render } from "./Waitlist.vue?vue&type=template&id=e54940a2&scoped=true"
import script from "./Waitlist.vue?vue&type=script&lang=js"
export * from "./Waitlist.vue?vue&type=script&lang=js"

import "./Waitlist.vue?vue&type=style&index=0&id=e54940a2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54940a2"]])

export default __exports__